import { useSyncExternalStore } from 'react';

/** Breakpoints für Handy und Tablet – dieselben Werte wie in app.css. */
export const HANDY = '(max-width: 700px)';
export const TABLET = '(max-width: 1100px)';

export const passt = (q: string) => typeof matchMedia === 'function' && matchMedia(q).matches;

/** React-Hook: true, solange die Media-Query zutrifft (rendert bei Wechsel neu, z. B. beim Drehen). */
export function useMedia(q: string) {
  return useSyncExternalStore(
    (cb) => {
      const m = matchMedia(q);
      m.addEventListener('change', cb);
      return () => m.removeEventListener('change', cb);
    },
    () => passt(q),
  );
}

export const useHandy = () => useMedia(HANDY);
